import script from "./camera-image.vue?vue&type=script&setup=true&lang=js"
export * from "./camera-image.vue?vue&type=script&setup=true&lang=js"

import "./camera-image.vue?vue&type=style&index=0&id=1bb419fc&lang=scss"

const __exports__ = script;

export default __exports__